<div class="fs-16" *ngIf="user">
    <p class="mb-3 grey-text" *ngIf="type!='share'">Invite coaches to give them videos access.</p>
    <div class="row mb-2 custom-inputs2">
        <div class="col-sm-12">
            <input type="text" id="dashboard-search-input2" [(ngModel)]="keyword"
            (ngModelChange)="updateOnlyOnBlur($event)" placeholder="Filter by E-mail"
            class="form-control">
        </div>
        <!-- <div _ngcontent-ivh-c54="" class="invalid-feedback d-block"> Please fill valid email. </div> -->
    </div>

    <ul class="connections-list" *ngIf="connections.length">
        <li class="grey-text" *ngFor="let connection of connections">
            <span>{{connection.connection_email}}</span>
                <span *ngIf="type=='share'" class="ms-auto">
                    <span class="share-to-connection" *ngIf="!checkInSharedConnections(selectedPlaylist,connection)" (click)="shareToConnection(selectedPlaylist,connection)"><i class="fa fa-plus" *ngIf="!addingToList || addingToList!=connection.connection_user_id"></i><i class="fa fa-spinner fa-spin" *ngIf="addingToList==connection.connection_user_id"></i></span>
                    <span class="share-to-connection added" *ngIf="checkInSharedConnections(selectedPlaylist,connection)" (click)="shareToConnection(selectedPlaylist,connection,'remove')"><i class="fa fa-minus" *ngIf="!removingFromList || removingFromList!=connection.connection_user_id"></i><i class="fa fa-spinner fa-spin" *ngIf="removingFromList==connection.connection_user_id"></i></span>
                </span>
                <span class="d-inline-block icon-delete" [ngClass]="{'ms-auto': type != 'share'}"
                (click)="removeConnection(connection.connection_id)">
                <i *ngIf="removingConnection==connection.id" class="fa fa-spinner fa-spin"></i> <i class="fa fa-trash-can"></i>
            </span>
        </li>
    </ul>

    <form *ngIf="user && user.coach_invites_left>0 && type!='share'" class="invite-form" [formGroup]="inviteForm"
        (ngSubmit)="onSubmit(inviteForm)">
        <p class="text-red" *ngIf="connections.length==0 && keyword.length==0">Oops! No Coach has been invited. Start inviting now.</p>
        <p class="text-red" *ngIf="connections.length==0 && keyword.length>0">Sorry, Can't find this connection.</p>
        <div class="row mb-2 custom-inputs2">
            <div class="col-sm-12">
                <input type="text" id="dashboard-search-input" formControlName="email"
                    placeholder="Enter new coach e-mail" class="form-control">
                <div class="invalid-feedback d-block"
                    *ngIf="(f['email'].errors?.['required'] || f['email'].errors?.['email']) && (f['email'].dirty || f['email'].touched)">
                    Please fill valid email.
                </div>
            </div>
            <!-- <div _ngcontent-ivh-c54="" class="invalid-feedback d-block"> Please fill valid email. </div> -->
        </div>
        <div class="text-end"><button type="submit" class="btn mt-3 btn-gold">Invite Coach <i *ngIf="formSubmitting"
                    class="fa fa-spinner fa-spin"></i></button></div>
    </form>
</div>